// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__xr61u","rotation":"loader_rotation__wieTh"};